export default {
  SET_GRID_DATA_ACCOUNT_DETAIL(state, params) {
    state.gridData = params;
  },

  SET_SEARCH_PARAM_ACCOUNT_DETAIL(state, params) {
    state.searchParam = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/detail/accountDetailMutation.js